import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from 'services/Auth';

class ServicesApi extends Api {
  constructor() {
    super('website/services/');
  }

  // GET all services with filters
  list = (params = {}) => {
    return this.buildQuery('get', { params });
  };

  // GET one service by ID
  show = (id) => {
    return this.buildQuery('get', {}, id);
  };

  // Create new service
  create = (data) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/website/services`,
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data',
        'auth-token': AuthService.getToken(),
      },
      data,
    });
  };

  // Update service
  update = (id, data) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const url = `${apiUrl}/website/services/${id}`;
    console.log('Update request URL:', url);

    // Log FormData entries
    if (data instanceof FormData) {
      console.log('Update request FormData entries:');
      for (let pair of data.entries()) {
        console.log(
          pair[0],
          ':',
          pair[1] instanceof File ? `File(${pair[1].name})` : pair[1],
        );
      }
    }

    return axios({
      url,
      method: 'put',
      headers: {
        'Content-Type': 'multipart/form-data',
        'auth-token': AuthService.getToken(),
      },
      data,
    });
  };

  // Delete service attachments
  deleteFile = (id, fileId) => {
    return this.buildQuery(
      'delete',
      {
        data: {
          ids: fileId,
        },
      },
      `${id}/remove_attachments`,
    );
  };

  // Delete service
  delete = (id) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const url = `${apiUrl}/website/services/${id}`;
    console.log('Delete request URL:', url);

    return axios({
      url,
      method: 'delete',
      headers: {
        Accept:
          'text/xml,application/xml,application/xhtml+xml,text/html;q=0.9,text/plain;q=0.8,image/png,*/*;q=0.5',
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
      data: {
        ids: id,
      },
    });
  };

  // Get filters data (shopping centers, chains, companies, etc)
  getFilters = () => {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/filters`,
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  };

  // Export to Excel
  getExcel = (params) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/services.xlsx`,
      method: 'get',
      data: params.data,
      params: params.params,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
        ...(params?.headers || {}),
        'auth-token': AuthService.getToken(),
      },
    });
  };
}

export default new ServicesApi();
